<!-- 登录弹窗 -->
<template>
  <el-dialog
    :visible.sync="visible"
    width="30%"
    :before-close="handleClose"
    custom-class="dialog-login"
    :close-on-click-modal="false"
  >
    <div class="text-center" slot="title">登录</div>
    <el-form :model="form" :rules="rules" ref="form">
      <el-form-item prop="phone">
        <el-input prefix-icon="el-icon-user" placeholder="请输入手机号" v-model="form.phone"></el-input>
      </el-form-item>
      <el-form-item prop="password">
        <el-input type="password" prefix-icon="el-icon-lock" placeholder="请输入密码" v-model="form.password"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <span class="inline-block text-[14px] mb-[10px] cursor-pointer" @click="openRegisterDialog"
        >没有账号？快速注册</span
      >
      <el-button type="primary" @click="submitForm()" style="width: 100%" :disabled="loginButtonDisabled"
        >登 录</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { EventBus } from '@/utils/eventbus';

export default {
  name: 'DialogLogin',
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loginButtonDisabled: false,
      form: {
        phone: this.$testUsername || '',
        password: this.$testPassword || '',
      },
      rules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^(?:(?:\+|00)86)?1\d{10}$/, message: '请输入正确的手机号', trigger: ['blur', 'change'] },
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '密码长度在 6 到 20 个字符', trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    submitForm() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$store
            .dispatch('login', this.form)
            .then(() => {
              this.$message.success('登录成功');
              EventBus.$emit('dialogLoginVisible', false);
            })
            .catch((err) => {});
        }
      });
    },
    handleClose() {
      this.$refs['form'].resetFields();
      EventBus.$emit('dialogLoginVisible', false);
    },
    openRegisterDialog() {
      this.$refs['form'].resetFields();
      EventBus.$emit('dialogRegisterVisible', true);
      EventBus.$emit('dialogLoginVisible', false);
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .dialog-login {
  padding: 0 30px 10px;
}
</style>
